module.exports = __webpack_public_path__ + "static/media/linkedin.55aafdc3.svg";